import { render } from "./Register2.vue?vue&type=template&id=2ab0433a&scoped=true"
import script from "./Register2.vue?vue&type=script&lang=js"
export * from "./Register2.vue?vue&type=script&lang=js"

import "./Register2.vue?vue&type=style&index=0&id=2ab0433a&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab0433a"]])

export default __exports__